import { Antrag } from '../../types';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentageOfMaxSize',
  standalone: true,
})
export class PercentageOfMaxSizePipe implements PipeTransform {
  public async transform(
    antrag: Antrag,
    maximumSize: number, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    justSomethingToTrickChangeDetection: number,
  ): Promise<number> {
    const currentSize = await antrag.getSizeInBytes();
    const currentSizeInMb = currentSize / 1024 / 1024;
    const percentage = (currentSizeInMb / maximumSize) * 100;

    return percentage > 100 ? 100 : Math.round(percentage);
  }
}
